import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Card, Placeholder } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useToken from 'hooks/useToken';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

const SubscriptionInfo = ({ idSuscripcion, info, onRefreshInfo }) => {
    const { token } = useToken();
    info = info || {};

    // Si 'info' no tiene datos todavía, asumimos que está cargando
    const isLoading = Object.keys(info).length === 0;

    //PETICIONES PARA LA EDICION DEL STRIPE
    const [isEditing, setIsEditing] = useState(false);
    const [nuevoStripeId, setNuevoStripeId] = useState("");

    //PARA COPIAR
    const [isCopied, setIsCopied] = useState(false);
    const [isLinkCopied, setIsLinkCopied] = useState(false);
    const [urlBasePagos, setUrlBasePagos] = useState('http://localhost:5173/?');

    // CAMBIO DE TARJETA CON STRIPE
    const [generandoLinkTarjeta, setGenerandoLinkTarjeta] = useState(false);
    const [isLinkTarjetaCopied, setIsLinkTarjetaCopied] = useState(false);

    const generarLinkCambioTarjeta = async () => {
        const stripeSubId = info.vStripeSubscriptionId || info.StripeId;
        const idSub = idSuscripcion || info.idSuscripcion;

        if (!idSub && !stripeSubId) {
            toast.error('Faltan datos de suscripción para generar el link de cambio de tarjeta.');
            return;
        }

        try {
            setGenerandoLinkTarjeta(true);
            const response = await fetch('/api/Suscripciones/GenerarLinkCambioTarjeta', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    idSuscripcion: idSub ? parseInt(idSub) : null,
                    vStripeSubscriptionId: stripeSubId
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1 && data.detalles?.url) {
                    const linkUrl = data.detalles.url;

                    let copiadoExitoso = false;
                    try {
                        await navigator.clipboard.writeText(linkUrl);
                        copiadoExitoso = true;
                    } catch (clipboardError) {
                        const textArea = document.createElement('textarea');
                        textArea.value = linkUrl;
                        textArea.style.position = 'fixed';
                        textArea.style.left = '-999999px';
                        textArea.style.top = '-999999px';
                        document.body.appendChild(textArea);
                        textArea.focus();
                        textArea.select();
                        try {
                            document.execCommand('copy');
                            copiadoExitoso = true;
                        } catch (execError) {
                            console.error('Error al copiar link de tarjeta:', execError);
                        }
                        document.body.removeChild(textArea);
                    }

                    if (copiadoExitoso) {
                        setIsLinkTarjetaCopied(true);
                        setTimeout(() => setIsLinkTarjetaCopied(false), 3000);
                        toast.success('Link de cambio de tarjeta generado y copiado al portapapeles.', { theme: 'colored' });
                    } else {
                        toast.error('Link generado pero no se pudo copiar automáticamente.');
                    }
                } else {
                    toast.error(data.vMessage || 'No se pudo generar el link de cambio de tarjeta.');
                }
            } else {
                toast.error(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            toast.error('Error al generar link de cambio de tarjeta: ' + error.message);
        } finally {
            setGenerandoLinkTarjeta(false);
        }
    };

    //FETCH PARA LOS DATOS DEL STRIPEID
    const GuardarEdicion = async () => {
        try {
            const response = await fetch(`/api/Suscripciones/ActualizarStripeId`, {
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "idSuscripcion": parseInt(idSuscripcion), "vStripeSubscriptionId": nuevoStripeId

                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    setIsEditing(false); // Salir del modo edición
                    if (onRefreshInfo) onRefreshInfo(); // Volver a consultar la BD para refrescar la vista
                    toast.success("¡Stripe ID actualizado correctamente!", {
                        theme: 'colored',
                    });
                } else {
                    console.log("Error al actualizar:", data.vMessage);
                    toast.error("Error al actualizar el Stripe ID");
                }
            }
        } catch (error) {
            console.error("Error de conexión al guardar", error);
        }
    };

    // Eliminado: ObtenerInfo (ahora se obtiene desde el componente padre)


    const obtenerUrlBasePagos = async () => {
        try {
            const response = await fetch('/api/Suscripciones/ObtenerUrlBasePagos', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles?.urlBase) {
                setUrlBasePagos(data.detalles.urlBase);
            }
        } catch (error) {
            console.error('Error obteniendo URL base de pagos:', error);
        }
    };

    useEffect(() => {
        obtenerUrlBasePagos();
    }, []);

    const fallbackCopyTextToClipboard = (text) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
            setIsLinkCopied(true);
            setTimeout(() => setIsLinkCopied(false), 2000);
            toast.success('Link de pago copiado.', { theme: 'colored' });
        } catch (execError) {
            console.error('Error al copiar con execCommand:', execError);
            toast.error('No se pudo copiar el enlace. Por favor, cópialo manualmente.');
        }

        document.body.removeChild(textArea);
    };

    const copiarLinkPago = () => {
        if (!info.vUUIDEmpresa || !info.vUUIDLicencia || !info.vUUIDSuscripcion) {
            toast.error('Faltan datos para generar el enlace (UUIDs faltantes).');
            return;
        }

        const idProductoPrecio = Number(info.idProductoPrecio || 0);
        if (!idProductoPrecio || Number.isNaN(idProductoPrecio)) {
            toast.error('No se pudo generar el enlace: falta idProductoPrecio.');
            return;
        }

        const payload = {
            idProductoPrecio,
            idClienteAkasia: Number(info.idClienteAkasia || 0),
            esSuscripcion: 1,
            uuidEmpresa: info.vUUIDEmpresa,
            uuidLicencia: info.vUUIDLicencia,
            uuidSuscripcion: info.vUUIDSuscripcion
        };

        const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
        const paymentUrl = `${urlBasePagos}vSub=${encodeURIComponent(encoded)}`;

        try {
            navigator.clipboard.writeText(paymentUrl).then(() => {
                setIsLinkCopied(true);
                setTimeout(() => setIsLinkCopied(false), 2000);
                toast.success('Link de pago copiado.', { theme: 'colored' });
            }).catch(() => {
                fallbackCopyTextToClipboard(paymentUrl);
            });
        } catch (error) {
            fallbackCopyTextToClipboard(paymentUrl);
        }
    };

    const formateaFecha = (fecha) => {
        if (!fecha) return '';

        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        const date = new Date(fecha);

        const dia = date.getUTCDate();
        const mes = meses[date.getUTCMonth()];
        const anio = date.getUTCFullYear();

        return `${dia} ${mes} ${anio}`;
    };
    return (
        <Card className="border-0 shadow-sm rounded-3 mb-4 h-100" style={{ fontFamily: '"Open Sans", sans-serif' }}>
            <Card.Body className="p-4">
                {/* SECCIÓN CLIENTE MOVIDA A SubscriptionClientInfo */}

                <h6 className="fw-bold mb-4 d-flex align-items-center" style={{ fontSize: '1rem' }}>
                    <FontAwesomeIcon icon="info-circle" className="text-primary me-2" />
                    Información de la Suscripción
                </h6>

                <div className="mb-4">
                    <span className="text-muted fw-bold d-block text-uppercase mb-2" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                        STRIPE ID
                    </span>

                    <div className="d-flex align-items-center justify-content-between p-2 rounded border">
                        {isEditing && !isLoading ? (
                            <>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={nuevoStripeId}
                                    onChange={(e) => setNuevoStripeId(e.target.value)}
                                />
                                <div className="text-nowrap ms-2">
                                    <Button variant="link" className="p-0 text-success me-3" onClick={() => { GuardarEdicion(); }}>
                                        <FontAwesomeIcon icon="check" />
                                    </Button>
                                    <Button variant="link" className="p-0 text-danger" onClick={() => { setIsEditing(false); }}>
                                        <FontAwesomeIcon icon="times" />
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <span className="font-monospace text-truncate d-block" style={{ fontSize: '0.85rem' }}>
                                    {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={8} /></Placeholder> : (info.vStripeSubscriptionId || 'Sin Registro')}
                                </span>
                                {!isLoading && (
                                    <div className="text-nowrap ms-2">
                                        <Button variant="link" className="p-0 text-primary me-3" title="Editar Stripe ID" onClick={() => {
                                            setIsEditing(true);
                                            setNuevoStripeId(info.vStripeSubscriptionId);
                                        }}>
                                            <FontAwesomeIcon icon="edit" />
                                        </Button>
                                        <Button
                                            variant="link"
                                            className="p-0 text-secondary"
                                            title="Copiar Stripe ID"
                                            onClick={() => {
                                                if (info.vStripeSubscriptionId) {
                                                    navigator.clipboard.writeText(info.vStripeSubscriptionId);


                                                    setIsCopied(true);
                                                    setTimeout(() => {
                                                        setIsCopied(false);
                                                    }, 2000)
                                                }
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={isCopied ? "check" : "copy"}
                                                className={isCopied ? "text-success" : ""}
                                            />
                                        </Button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>

                {/* Link de Cambio de Tarjeta con Stripe (cuando existe Stripe ID) */}
                {(!isLoading && info.vStripeSubscriptionId) && (
                    <Row className="mb-3 border-bottom pb-3 mx-0 align-items-center">
                        <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Cambiar Tarjeta</Col>
                        <Col xs={6} className="text-end px-0" style={{ fontSize: '0.85rem' }}>
                            <Button
                                variant="outline-info"
                                size="sm"
                                className="fw-semibold px-3 py-1 rounded-pill text-nowrap"
                                style={{ fontSize: '0.8rem' }}
                                onClick={generarLinkCambioTarjeta}
                                disabled={generandoLinkTarjeta}
                            >
                                {generandoLinkTarjeta ? (
                                    <FontAwesomeIcon icon="spinner" spin className="me-1" />
                                ) : (
                                    <FontAwesomeIcon
                                        icon={isLinkTarjetaCopied ? "check" : "credit-card"}
                                        className={`me-1 ${isLinkTarjetaCopied ? "text-success" : ""}`}
                                    />
                                )}
                                {isLinkTarjetaCopied ? "¡Link Copiado!" : "Generar link"}
                            </Button>
                        </Col>
                    </Row>
                )}

                {/* Link de Pago - Solo se muestra si NO hay Stripe ID y la suscripción está ACTIVA */}
                {(!isLoading && !info.vStripeSubscriptionId && info.vEstadoSuscripcion === 'ACTIVA') && (
                    <Row className="mb-3 border-bottom pb-3 mx-0">
                        <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Link de Pago</Col>
                        <Col xs={6} className="text-end px-0" style={{ fontSize: '0.85rem' }}>
                            <Button
                                variant="link"
                                className="p-0 text-primary text-decoration-none fw-semibold"
                                onClick={copiarLinkPago}
                                disabled={!info.vUUIDSuscripcion}
                            >
                                <FontAwesomeIcon icon={isLinkCopied ? "check" : "link"} className={`me-2 ${isLinkCopied ? "text-success" : ""}`} />
                                {isLinkCopied ? "¡Copiado!" : "Copiar enlace"}
                            </Button>
                        </Col>
                    </Row>
                )}

                <Row className="mt-4">
                    {/* Columna Izquierda */}
                    <Col xs={12} lg={6} className="pe-lg-4 mb-4 mb-lg-0">
                        {/* Total */}
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Total Suscripción</span>
                            <span className={`text-end ${isLoading ? '' : info.dTotal ? 'fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                                {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={4} bg="secondary" style={{ width: '50px' }} /></Placeholder> : info.dTotal ? `$${info.dTotal} ${info.vMoneda || ''}` : 'Sin cobro'}
                            </span>
                        </div>

                        {/* Moneda */}
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Moneda</span>
                            <span className={`text-end ${isLoading ? '' : 'fw-bold'}`} style={{ fontSize: '0.85rem' }}>
                                {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={3} bg="secondary" style={{ width: '40px' }} /></Placeholder> : info.vMoneda || 'Sin definir'}
                            </span>
                        </div>

                        {/* Periodo de Cobro */}
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Periodo de Cobro</span>
                            <span className="text-end" style={{ fontSize: '0.85rem' }}>
                                {isLoading ? (
                                    <Placeholder as="span" animation="glow"><Placeholder xs={5} bg="secondary" style={{ width: '60px' }} /></Placeholder>
                                ) : info.vTipoRenovacion ? (
                                    <span className="badge bg-primary text-white text-uppercase" style={{ fontSize: '0.7rem' }}>{info.vTipoRenovacion}</span>
                                ) : (
                                    <span className="text-muted fst-italic">Sin definir</span>
                                )}
                            </span>
                        </div>

                        {/* Cancelada por (Condicional) */}
                        {(!isLoading && info.vCanceladoUser) && (
                            <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                                <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Cancelada por</span>
                                <span className="text-end text-danger fw-bold" style={{ fontSize: '0.85rem', wordBreak: 'break-word' }}>
                                    {info.vCanceladoUser}
                                </span>
                            </div>
                        )}
                    </Col>

                    {/* Columna Derecha */}
                    <Col xs={12} lg={6}>
                        {/* Fecha de Inicio */}
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Fecha de Inicio</span>
                            <span className={`text-end ${isLoading ? '' : (info.dCreatedDate || info.dFechaAlta) ? 'fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                                {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={6} bg="secondary" style={{ width: '80px' }} /></Placeholder> : (info.dCreatedDate || info.dFechaAlta) ? formateaFecha(info.dCreatedDate || info.dFechaAlta) : 'Sin fecha'}
                            </span>
                        </div>

                        {/* Siguiente Pago */}
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Siguiente Pago</span>
                            <span className={`text-end ${isLoading ? '' : info.dProximoPago ? 'text-primary fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                                {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={6} bg="secondary" style={{ width: '80px' }} /></Placeholder> : info.dProximoPago ? formateaFecha(info.dProximoPago) : 'Sin próximo pago'}
                            </span>
                        </div>

                        {/* Creada por */}
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Creada por</span>
                            <span className={`text-end text-uppercase ${isLoading ? '' : info.vCreatedUser ? 'fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem', wordBreak: 'break-word' }}>
                                {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={10} bg="secondary" style={{ width: '100px' }} /></Placeholder> : info.vCreatedUser || 'Sin creador'}
                            </span>
                        </div>

                        {/* Fecha Cancelación (Fin de servicio) */}
                        {(!isLoading && info.dFechaCancelacion) && (
                            <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                                <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Fecha fin por cancelación</span>
                                <span className="text-end text-danger fw-bold" style={{ fontSize: '0.85rem' }}>
                                    {formateaFecha(info.dFechaCancelacion)}
                                </span>
                            </div>
                        )}

                        {/* Fecha Cancelado (Fecha de ejecución) */}
                        {(!isLoading && info.dFechaCancelado) && (
                            <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                                <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Fecha cancelada</span>
                                <span className="text-end text-danger fw-bold" style={{ fontSize: '0.85rem' }}>
                                    {formateaFecha(info.dFechaCancelado)}
                                </span>
                            </div>
                        )}
                    </Col>
                </Row>

            </Card.Body>
        </Card>
    );
};

SubscriptionInfo.propTypes = {
    idSuscripcion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    info: PropTypes.object,
    onRefreshInfo: PropTypes.func
};

export default SubscriptionInfo;